import { render, staticRenderFns } from "./WatchVideos.vue?vue&type=template&id=39af0a53&scoped=true&"
import script from "./WatchVideos.vue?vue&type=script&lang=js&"
export * from "./WatchVideos.vue?vue&type=script&lang=js&"
import style0 from "./WatchVideos.vue?vue&type=style&index=0&id=39af0a53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af0a53",
  null
  
)

export default component.exports